import React from 'react';
import SideNav from '../components/SideNav'; // Import the new SideNav

const MillionWall = () => {
  // Placeholder data for achievement posts
  const posts = [
      { id: 1, name: 'Alex Chen', username: 'MOB-x9y8z7', profilePic: 'https://via.placeholder.com/50', achievement: 'Just hit my first  month! The Sales Lab scripts are absolute gold.' },
      { id: 2, name: 'Sarah Jones', username: 'MOB-a1b2c3', profilePic: 'https://via.placeholder.com/50', achievement: 'Officially launched my Shopify store today. 50 pre-orders in the first hour.' },
      { id: 3, name: 'Mike D.', username: 'MOB-f4g5h6', profilePic: 'https://via.placeholder.com/50', achievement: 'Quit my 9-5. It\'s all in on M.O.B. now. The Identity Shift module changed everything.' }
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#000' }}>
      <SideNav activePage="million-wall" /> {/* Add SideNav */}
      <div style={{ flex: 1, padding: '40px', color: '#fff', fontFamily: 'Inter, sans-serif' }}>
        <h1 style={{ fontFamily: 'Orbitron', color: '#D4AF37', borderBottom: '2px solid #D4AF37', paddingBottom: '15px', marginBottom: '30px' }}>THE MILLION WALL</h1>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '800px' }}>
            {posts.map(post => (
                <div key={post.id} style={{ background: '#111', border: '1px solid #333', padding: '20px', borderRadius: '8px', display: 'flex', gap: '20px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', minWidth: '100px' }}>
                        <img src={post.profilePic} alt="Profile" style={{ width: '60px', height: '60px', borderRadius: '50%', border: '2px solid #D4AF37' }} />
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ fontWeight: 'bold', color: '#fff' }}>{post.name}</div>
                            <div style={{ fontSize: '0.8rem', color: '#888' }}>@{post.username}</div>
                        </div>
                    </div>
                    <div style={{ flex: 1, background: '#0a0a0a', padding: '15px', borderRadius: '5px', border: '1px solid #222', color: '#ccc', lineHeight: '1.6' }}>
                        {post.achievement}
                    </div>
                </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default MillionWall;
